import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsDashboardsDetailRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-dashboards-detail',
	path: '/jira/servicedesk/assets/dashboards/:templateId',
	exact: true,
};
